export const isAuthenticated = (state) => {
    const auth = state?.auth?.auth || {};
    console.log('🔍 isAuthenticated check:', {
        hasIdToken: !!auth.idToken,
        hasToken: !!auth.token,
        auth: auth,
        result: Boolean(auth.idToken || auth.token)
    });
    return Boolean(auth.idToken || auth.token);
};
